// extracted by mini-css-extract-plugin
export default {"goTopButton":"goTopButton__1uEYQ"};